<template>
  <div class="col-md-12 transport-costs">
    <div class="row">
      <div class="col-md-8 label-col">
        <label v-translation="{ code: 'label_transport_costs', type: 'label' }"></label>
      </div>
      <div class="col-md-4">
        <utlz-decimal-field :maxValue="maxValue" :initialValue="quotation.transportCosts" @valueUpdatedEvent="updateTransportCosts($event)"></utlz-decimal-field>
      </div>
    </div>
  </div>
</template>

<script>
import DecimalField from './../../bespoke/quotations/DecimalField.vue';
export default {
  props: {
    quotation: { type: Object, required: true}
  },
  data() {
    return {
      maxValue: 0,
      discountAmountLabel: window.vue.translations.label.label_quote_dd_disc_amt,
      discountPercentageLabel: window.vue.translations.label.label_quote_dd_disc_perc
    };
  },
  components: {
    'utlz-decimal-field': DecimalField
  },
  methods: {
    updateTransportCosts(amount) {
      this.$emit('onUpdateTransportCosts', amount);
    },
    setDiscountMaxValue(discountType) {
      if (discountType === 0) {
        this.maxValue = 0;
      } else if (discountType === 1) {
        this.maxValue = 100;
      }
    }
  }
}
</script>

<style>

</style>